import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type ProductionItemCatalogFieldsFragment = { __typename?: 'ProductionItemCatalogEntry', productionItemId: string, productionItemNumber: string, genus: string, series: string, color: string, category: string };

export type ItemProductionMappingStateFragment = { __typename?: 'ItemProductionMappingStateData', salesItemId: string, updatedAt: Types.TDateISO, updatedBy: string, lines: Array<{ __typename?: 'ItemProductionMappingLineStateData', productionItemId: string, mixPct: number, startIsoYear?: number | null, startIsoWeek?: number | null, endIsoYear?: number | null, endIsoWeek?: number | null, regions: Array<string> }> };

export type GetItemProductionMappingsQueryVariables = Types.Exact<{
  salesItemId: Types.Scalars['String']['input'];
}>;


export type GetItemProductionMappingsQuery = { __typename?: 'Query', itemProductionMappings?: { __typename?: 'ItemProductionMappingDocument', id: string, salesItemId: string, updatedAt: Types.TDateISO, updatedBy: string, lines: Array<{ __typename?: 'ItemProductionMappingLineDocument', productionItemId: string, mixPct: number, startIsoYear?: number | null, startIsoWeek?: number | null, endIsoYear?: number | null, endIsoWeek?: number | null, regions: Array<string>, productionItem?: { __typename?: 'ProductionItemCatalogEntry', productionItemId: string, productionItemNumber: string, genus: string, series: string, color: string, category: string } | null }> } | null };

export type GetProductionItemsCatalogQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetProductionItemsCatalogQuery = { __typename?: 'Query', productionItemsCatalog: Array<{ __typename?: 'ProductionItemCatalogEntry', productionItemId: string, productionItemNumber: string, genus: string, series: string, color: string, category: string }> };

export const ProductionItemCatalogFieldsFragmentDoc = new TypedDocumentString(`
    fragment ProductionItemCatalogFields on ProductionItemCatalogEntry {
  productionItemId
  productionItemNumber
  genus
  series
  color
  category
}
    `, {"fragmentName":"ProductionItemCatalogFields"});
export const ItemProductionMappingStateFragmentDoc = new TypedDocumentString(`
    fragment ItemProductionMappingState on ItemProductionMappingStateData {
  salesItemId
  updatedAt
  updatedBy
  lines {
    productionItemId
    mixPct
    startIsoYear
    startIsoWeek
    endIsoYear
    endIsoWeek
    regions
  }
}
    `, {"fragmentName":"ItemProductionMappingState"});
export const GetItemProductionMappingsDocument = new TypedDocumentString(`
    query GetItemProductionMappings($salesItemId: String!) {
  itemProductionMappings(salesItemId: $salesItemId) {
    id
    salesItemId
    updatedAt
    updatedBy
    lines {
      productionItemId
      mixPct
      startIsoYear
      startIsoWeek
      endIsoYear
      endIsoWeek
      regions
      productionItem {
        ...ProductionItemCatalogFields
      }
    }
  }
}
    fragment ProductionItemCatalogFields on ProductionItemCatalogEntry {
  productionItemId
  productionItemNumber
  genus
  series
  color
  category
}`);
export const GetProductionItemsCatalogDocument = new TypedDocumentString(`
    query GetProductionItemsCatalog {
  productionItemsCatalog {
    ...ProductionItemCatalogFields
  }
}
    fragment ProductionItemCatalogFields on ProductionItemCatalogEntry {
  productionItemId
  productionItemNumber
  genus
  series
  color
  category
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetItemProductionMappings: build.query<GetItemProductionMappingsQuery, GetItemProductionMappingsQueryVariables>({
      query: (variables) => ({ document: GetItemProductionMappingsDocument, variables })
    }),
    GetProductionItemsCatalog: build.query<GetProductionItemsCatalogQuery, GetProductionItemsCatalogQueryVariables | void>({
      query: (variables) => ({ document: GetProductionItemsCatalogDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetItemProductionMappingsQuery, useLazyGetItemProductionMappingsQuery, useGetProductionItemsCatalogQuery, useLazyGetProductionItemsCatalogQuery } = injectedRtkApi;
